import React from "react";

function CopyOutlinedIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='16' fill='none' viewBox='0 0 14 16'>
      <path
        fill='#2A94FF'
        d='M4.5 13c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 013 11.5v-10c0-.413.147-.766.44-1.06C3.735.148 4.089 0 4.5 0h8c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06v10c0 .412-.147.766-.44 1.06-.294.293-.648.44-1.06.44h-8zm0-1.5h8v-10h-8v10zm-3 4.5c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 010 14.5V3h1.5v11.5H11V16H1.5z'></path>
    </svg>
  );
}

export default CopyOutlinedIcon;